import { render, staticRenderFns } from "./editLevel2TagModal.vue?vue&type=template&id=ec488d0e&scoped=true"
import script from "./editLevel2TagModal.vue?vue&type=script&lang=js"
export * from "./editLevel2TagModal.vue?vue&type=script&lang=js"
import style0 from "./editLevel2TagModal.vue?vue&type=style&index=0&id=ec488d0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec488d0e",
  null
  
)

export default component.exports